module.exports = __webpack_public_path__ + "public/images/singing-background-pattern.f1fb06cd14b08cd70440cef1317fdce9.svg";